// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"_Y3b7AStm"};